<ion-content class="ion-padding">
  <ion-toolbar color="translucent">
    <ion-buttons slot="start" class="modalBack">
      <ion-button fill="clear" (click)="goBack()">
        <ion-icon class="back-button" src="assets/imgs/Icon-akar-arrow-left.svg" alt="Veggly Logo"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="badgeContainer">
    <div class="titleBadge">
      <!-- <ion-badge>
        {{ 'signUp' | translate }}
      </ion-badge> -->
    </div>
  </div>

  <div class="imgDiv">
    <img src="assets/imgs/logo.svg" alt="Flamr Logo">
  </div>

  <div class="welcome">
    {{ 'signUp' | translate }}
  </div>

  <div class="formSection">
    <ion-list>
      <div class="fillyourdetails">
        <span> {{ 'enterEmailPassValidationCodeWillBeSent' | translate }}</span>
      </div>
      <form [formGroup]="signupWithEmailForm">
        <ion-item lines="none" class="custom"
          [class.invalid]="!signupWithEmailForm.controls.emailControl.valid && (signupWithEmailForm.controls.emailControl.dirty || submitAttempt)">
          <ion-icon slot="start" name="mail-outline"></ion-icon>
          <ion-input clearInput placeholder="Email" type="email" formControlName="emailControl"></ion-input>
        </ion-item>
        <ion-item class="alert"
          *ngIf="!signupWithEmailForm.controls.emailControl.valid && (signupWithEmailForm.controls.emailControl.dirty || submitAttempt)">
          <p>{{'validEmailMsg' | translate}}</p>
        </ion-item>


        <ion-item lines="none" class="custom"
          [ngClass]="{'invalid': !signupWithEmailForm.controls.userpassControl.valid && (signupWithEmailForm.controls.userpassControl.dirty || submitAttempt)}">
          <ion-icon slot="start" name="lock-closed"></ion-icon>
          <ion-input [type]="show ? 'text' : 'password'" class="custom" placeholder="{{'password' | translate}}"
            type="password" formControlName="userpassControl"></ion-input>
          <ion-icon (click)="password()" slot="end" [name]="show ? 'eye' : 'eye-off-outline'"
            aria-hidden="true"></ion-icon>
        </ion-item>

        <ion-item class="alert"
          *ngIf="!signupWithEmailForm.controls.userpassControl.valid && (signupWithEmailForm.controls.userpassControl.dirty || submitAttempt)">
          <p>{{'validPasswordMsg' | translate}}</p>

        </ion-item>

        <ion-item lines="none" class="custom"
          [ngClass]="{'invalid': !signupWithEmailForm.controls.reenterpassControl.valid && (signupWithEmailForm.controls.reenterpassControl.dirty || submitAttempt)}">
          <ion-icon slot="start" name="lock-closed"></ion-icon>
          <ion-input [type]="show ? 'text' : 'password'" class="custom" placeholder="{{'reenterPassword' | translate}}"
            type="password" formControlName="reenterpassControl"></ion-input>
          <ion-icon (click)="password()" slot="end" [name]="show ? 'eye' : 'eye-off-outline'"
            aria-hidden="true"></ion-icon>
        </ion-item>

        <ion-item class="alert"
          *ngIf="!signupWithEmailForm.controls.reenterpassControl.valid && (signupWithEmailForm.controls.reenterpassControl.dirty || submitAttempt)">
          <p>{{'reenterValidPassword' | translate}}</p>
        </ion-item>

      </form>
    </ion-list>
  </div>

  <!-- <div class="bottomButtons">
    <ion-button expand="full" class="buttonShadow" color="primary" shape="round" fill="solid" (click)="signMeUp()">
      {{ 'signMeUp' | translate }}
    </ion-button>
    <ion-button expand="full" color="primary" class="buttonShadow" shape="round" fill="outline" (click)="alreadyHaveValCode()">
      {{ 'alreadyHaveValidationCode' | translate }}
    </ion-button>
  </div> -->

  <div class="bottomButtons">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="full" class="buttonShadow" color="primary" shape="round" fill="solid"
            (click)="signMeUp()">
            {{ 'signMeUp' | translate }}
          </ion-button>
        </ion-col>
        <!-- <ion-col size="6">
          <ion-button  (click)="goToForgotPasswordPage()" class="buttonShadow" expand="full" color="primary"  shape="round" fill="outline" >{{'forgotPassword' | translate}}</ion-button>
        </ion-col> -->
      </ion-row>
    </ion-grid>

    <ion-grid>
      <ion-row>
        <ion-col>
          <div class="notAUserBtn" (click)="alreadyHaveValCode()">
            <span class="validation-text">{{ 'alreadyHaveValidationCode' | translate }}</span>
          </div>
        </ion-col>
        <!-- <ion-col size="6">
          <ion-button  (click)="goToForgotPasswordPage()" class="buttonShadow" expand="full" color="primary"  shape="round" fill="outline" >{{'forgotPassword' | translate}}</ion-button>
        </ion-col> -->
      </ion-row>
    </ion-grid>



  </div>

</ion-content>